import React from 'react';
import { MB_Modal } from '@mightybyte/rnw.components.modal';
import { StyleSheet, Text, View, Linking, TouchableOpacity } from 'react-native';
import { GradientButton } from '../gradients/GradientButton';
import { mbTextStyles } from '@mightybyte/rnw.utils.style-utils';
import { FONT_STYLES, textStyles } from '../../../constants/textStyles';
import { Spacer } from '../Spacer';
import Fontisto from 'react-native-vector-icons/Fontisto';
import { envs } from '../../../../env';
import { getColors } from '../../../constants/colors';
import Feather from 'react-native-vector-icons/Feather';

const COLORS = getColors();

export type AccessRestrictedModalProps = {
  isVisible: boolean;
  onDismiss?: () => void;
  onLogOut: () => void;
};


export default function AccessRestrictedModal({ isVisible, onDismiss, onLogOut }: AccessRestrictedModalProps) {
  const handleVisitSupport = () => {
    Linking.openURL(envs.LINKS.help);
  };

  return (
    <MB_Modal
      isVisible={isVisible}
      onDismiss={() => onDismiss?.()}
      hideCloseButton
      childrenWrapperStyle={styles.container}
      withoutScrollView
    >
      <View style={styles.iconContainer}>
        <Fontisto name="locked" size={43} color={COLORS.orange} />
      </View>
      <Spacer height={20} />
      <Text style={styles.titleText}>ACCESS RESTRICTED</Text>
      <Spacer height={30} />
      <Text style={styles.messageText}>
        You are locked out during the duration of the current heat. For more information, please visit our support page.
      </Text>
      <Spacer height={40} />
      <View style={{ width: '100%' }}>
        <GradientButton
            title="GET HELP"
            style={styles.button}
            onPress={handleVisitSupport}
        />
        {/*<Spacer height={8} />*/}
        <TouchableOpacity
            style={styles.logOutContainer}
            onPress={onLogOut}
        >
          <Feather name="log-out" size={24} color="#F35E2E" />
          <Text style={styles.logOutText}>Log Out</Text>
        </TouchableOpacity>
      </View>

    </MB_Modal>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#EFEFF3',
    width: '90%',
    paddingHorizontal: 30,
    paddingTop: 40,
    paddingBottom: 40,
    alignItems: 'center',
  },
  iconContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  titleText: mbTextStyles([{
    fontFamily: FONT_STYLES.Tabasco_400,
    fontSize: 25,
    color: COLORS.orange,
    textAlign: 'center',
  }]),
  messageText: mbTextStyles([textStyles.normalText, {
    fontSize: 18,
    color: COLORS.primaryColor,
    textAlign: 'center',
    lineHeight: 24,
  }]),
  button: {
    width: '100%',
  },
  logOutContainer: {
    flexDirection: 'row',
    alignSelf: 'center',
    alignItems: 'center',
    marginTop: 20,
  },
  logOutText: mbTextStyles([
    textStyles.normalText,
    {
      color: COLORS.orange,
      fontWeight: '500',
      marginLeft: 5,
    },
  ]),
});
